import { db } from "../firebase";
import { doc, getDoc, setDoc, onSnapshot } from "firebase/firestore";

// Dati sensibili degli iscritti (codice fiscale) tenuti fuori dal documento corsi/{id}, che è
// leggibile pubblicamente dal link del report cliente (vedi firestore.rules). La sottocollezione
// corsi/{id}/riservato non è coperta da quella regola e ricade nel catch-all "solo autenticati".
function rifAnagrafica(corsoId) {
  return doc(db, "corsi", corsoId, "riservato", "anagrafica");
}

// Aggiunge/aggiorna i codici fiscali (mappa email -> CF) senza toccare quelli già salvati
export async function salvaCodiciFiscali(corsoId, codiciFiscali) {
  if (!Object.keys(codiciFiscali).length) return;
  const snap = await getDoc(rifAnagrafica(corsoId));
  const attuali = snap.exists() ? snap.data().codiciFiscali || {} : {};
  await setDoc(rifAnagrafica(corsoId), { codiciFiscali: { ...attuali, ...codiciFiscali } });
}

export function ascoltaCodiciFiscali(corsoId, callback) {
  return onSnapshot(
    rifAnagrafica(corsoId),
    (snap) => callback(snap.exists() ? snap.data().codiciFiscali || {} : {}),
    (err) => { console.error("Errore lettura anagrafica riservata:", err); callback({}); }
  );
}
